import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { VoiceCallRptResponse, VoiceCallRpt, VoiceCallCancelRpt, SAMVoiceCallReportObj, SAMVoiceCallFilterResponse } from '../../../../models/report.model';
import { CLPUser, UserResponse } from '../../../../models/clpuser.model';
import { eFeatures, eUserRole } from '../../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { ReportService } from '../../../../services/report.service';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { ViewChildren } from '@angular/core';
import { QueryList } from '@angular/core';

@Component({
    selector: 'app-voice-call-report',
    templateUrl: './voice-call-report.component.html',
    styleUrls: ['./voice-call-report.component.css'],
    providers: [GridConfigurationService]
})
export class VoiceCallReportComponent {
    //@ViewChild(MatSort) sort: MatSort;
    @ViewChild('totalCallsSort') totalCallsSort: MatSort;
    @ViewChild('inboundSort') inboundSort: MatSort;
    @ViewChild('outboundCallSort') outboundCallSort: MatSort;
    @ViewChild('outboundScheduledSort') outboundScheduledSort: MatSort;
    @ViewChild('samCancelledSort') samCancelledSort: MatSort;
    @ViewChild('inboundListSort') inboundListSort: MatSort;
    //@ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    totalCallsdataSource: MatTableDataSource<any>;
    inbounddataSource: MatTableDataSource<any>;
    outboundCalldataSource: MatTableDataSource<any>;
    outboundScheduleddataSource: MatTableDataSource<any>;
    samCancelledSortdataSource: MatTableDataSource<any>;
    dataSource: MatTableDataSource<any>;
    dataSourceIn: MatTableDataSource<any>;
    @ViewChild('pdfExport') pdfExport!: PDFExportComponent;
    displayColumns: string[];
    showSpinner: boolean = false;
    roleFeaturePermissions: RoleFeaturePermissions;
    user: CLPUser;
    private encryptedUser: string = '';
    userResponse: UserResponse;

    voiceCallFilter: SAMVoiceCallFilterResponse;
    isShowVoiceCallGrid: boolean = false;
    dateWarning: boolean = false;
    voiceCallData: SAMVoiceCallReportObj = <SAMVoiceCallReportObj>{};
    voiceCallResponse: VoiceCallRptResponse;
    voiceCallCancelRpt: VoiceCallCancelRpt[] = [];
    totalVoiceRpt: VoiceCallRpt[] = [];
    inboundRpt: VoiceCallRpt[] = [];
    inboundRptList: VoiceCallRpt[] = [];
    inboundRptTotalList: VoiceCallRpt[] = [];
    outScheduledRpt: VoiceCallRpt[] = [];
    outClickToCallRpt: VoiceCallRpt[] = [];
    voiceCallForm: FormGroup;
    total = [];
    totalIn = [];
    totalOut = [];
    totalscd = [];
    totalclk = [];
    totalcnl = [];
    columns = [
        { field: 'user', title: 'User', width: '100' },
        { field: 'team', title: 'Team', width: '100' },
        { field: 'office', title: 'Office', width: '80' },
        { field: 'contacts', title: 'Contacts', width: '40' },
        { field: 'calls', title: 'Calls', width: '40' },
        { field: 'noRing', title: '	No Ring', width: '40' },
        { field: 'connected', title: 'Connected', width: '40' },
        { field: 'less2min', title: '< 2 min', width: '40' },
        { field: 'bt2to5min', title: '2 to 5 min', width: '40' },
        { field: 'bt5to15min', title: '5 to 15 min', width: '40' },
        { field: 'bt15to30min', title: '15 to 30 min', width: '40' },
        { field: 'greater30min', title: '> 30 min', width: '40' },
        { field: 'answerRate', title: 'Answer Rate', width: '60' },
        { field: 'pitchRate', title: 'Pitch Rate', width: '60' },
        { field: 'averageLength', title: 'Avg Call', width: '60' },
        { field: 'callsPerDay', title: 'Connected Per Day', width: '100' },
        { field: 'pitchCallsPerDay', title: 'Pitch Calls Per Day', width: '100' },
    ];
    columnsCNL = [
        { field: 'user', title: 'User', width: '100' },
        { field: 'team', title: 'Team', width: '100' },
        { field: 'office', title: 'Office', width: '80' },
        { field: 'action', title: 'SAM Button', width: '40' },
        { field: 'calls', title: 'Calls', width: '40' },
        { field: 'cnt', title: 'Clicked', width: '40' }
    ];
    reorderColumnName: string = 'user,team,office,contacts,calls,noRing,connected,less2min,bt2to5min,bt5to15min,bt15to30min,greater30min,answerRate,pitchRate,averageLength,callsPerDay,pitchCallsPerDay';
    columnWidth: string = 'user:100,team:100,office:80,contacts:40,calls:40,noRing:40,connected:40,less2min:40,bt2to5min:40,bt5to15min:40,bt15to30min:40,greater30min:40,answerRate:60,pitchRate:60,averageLength:60,callsPerDay:100,pitchCallsPerDay50';
    arrColumnWidth: any[] = ['user:100,team:100,office:80,contacts:40,calls:40,noRing:40,connected:40,less2min:40,bt2to5min:40,bt5to15min:40,bt15to30min:40,greater30min:40,answerRate:60,pitchRate:60,averageLength:60,callsPerDay:pitchCallsPerDay50'];
    mobileColumnNames: string[];
    today = new Date();
    dtLastMonth = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1)
    dtEndLastMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 0);

    currentRange = new FormGroup({
        dateStart: new FormControl<Date | null>(this.dtLastMonth),
        dateEnd: new FormControl<Date | null>(this.dtEndLastMonth),
    });
    hiddenFields: string[] = ['noRing', 'pitchRate', 'answerRate', 'pitchCallsPerDay'];
    exporting1: boolean;
    exporting2: boolean;
    exporting3: boolean;
    exporting4: boolean;
    exporting5: boolean;
    constructor(private fb: FormBuilder,
        private _reportService: ReportService,
        private datepipe: DatePipe,
        public _gridCnfgService: GridConfigurationService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _router: Router) {
        this._localService.isMenu = true;
    }

    ngOnInit(): void {
        this.voiceCallForm = this.prepareTextMsgLogForm();
        if (!isNullOrUndefined(localStorage.getItem("token"))) {
            this.encryptedUser = localStorage.getItem("token");
            this.authenticateR(() => {
                if (!isNullOrUndefined(this.user)) {
                    //Kendo grid load call stopped.
                    //this.getGridConfiguration();
                    this.getSAMVoiceCAllFilterData();
                }
                else
                    this._router.navigate(['/login']);
            })
        }
        else
            this._router.navigate(['/login']);
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'voice_call_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('voice_call_grid').subscribe((value) => { }));
    //}
    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'voice_call_grid').subscribe((value) => this.getGridConfiguration());
    //}

    private async authenticateR(callback) {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.SAMVoiceCallReport)
            .then(async (result: UserResponse) => {
                if (result) {
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            this._gridCnfgService.user = this.user;
                            this.voiceCallForm = this.prepareTextMsgLogForm();
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
        callback();
    }

    async getSAMVoiceCAllFilterData() {
        await this._reportService.getSAMVoiceCallFilter(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID)
            .then(async (result: SAMVoiceCallFilterResponse) => {
                if (result)
                    this.voiceCallFilter = UtilityService.clone(result);
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getVoiceCallList() {
        if (new Date(this.voiceCallForm.controls.startDate.value) < new Date(this.voiceCallForm.controls.endDate.value)) {
            this.dateWarning = false;
            this.showSpinner = true;
            this.isShowVoiceCallGrid = true;
            this.copyVoiceCallFormValue();
            await this._reportService.getVoiceCallSummaryReport(this.encryptedUser, this.voiceCallData)
                .then(async (result: VoiceCallRptResponse) => {
                    if (result) {
                        this.voiceCallResponse = UtilityService.clone(result);
                        this.totalVoiceRpt = this.voiceCallResponse?.totalVoiceCallRptList?.filter(v => v.clpUserId != 0);
                        this.total = this._localService.getTotalforGrid(this.voiceCallResponse?.totalVoiceCallRptList?.filter(v => v.clpUserId == 0));

                        this.inboundRpt = this.voiceCallResponse?.allUserVoiceCallRptList;

                        this.inboundRptList = this.voiceCallResponse?.voiceCallRptList?.filter(l => l.clpUserId != 0);
                        this.inboundRptTotalList = this.voiceCallResponse?.voiceCallRptList?.filter(l => l.clpUserId == 0);
                        this.totalIn = this._localService.getTotalforGrid(this.inboundRptTotalList);

                        if (!isNullOrUndefined(this._gridCnfgService)) {
                            this._gridCnfgService.iterateConfigGrid(this.voiceCallResponse, "voice_call_grid");
                            this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('voice_call_grid');
                        }

                        this.outScheduledRpt = this.voiceCallResponse?.vCRptListOutScheduled?.filter(l => l.clpUserId != 0);
                        this.totalscd = this._localService.getTotalforGrid(this.voiceCallResponse?.vCRptListOutScheduled?.filter(l => l.clpUserId == 0));

                        this.outClickToCallRpt = this.voiceCallResponse?.VCRptListOutClickToCall?.filter(l => l.clpUserId != 0);
                        this.totalclk = this._localService.getTotalforGrid(this.voiceCallResponse?.VCRptListOutClickToCall?.filter(l => l.clpUserId == 0));

                        this.voiceCallCancelRpt = this.voiceCallResponse?.voiceCallCancelRptList?.filter(l => l.clpUserId != 0);
                        this.totalcnl = this._localService.getTotalforGrid(this.voiceCallResponse?.voiceCallCancelRptList?.filter(l => l.clpUserId == 0));


                        this.setTotalCallsGrid(this.totalVoiceRpt);
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        } else
            this.dateWarning = true;
    }

    setTotalInGrid(samDataList: any, rptType: string) {
        var _total = [];
        for (let j = 0; j < samDataList?.length; j++) {
            let k = 0;
            for (const property in samDataList[j]) {
                const val = this.forSplit(samDataList[j][property]);
                if (j == 0) {
                    _total.push(val ? Number(val) : 0);
                }
                else {
                    _total.push(val ? Number(val) + _total[k] : _total[k]);
                }
                k++;
            }
            if (j != 0)
                _total.splice(0, k);
        }

        switch (rptType) {
            case 'vcTotal':
                this.total = _total;
                break;
            case 'outTotal':
                this.totalOut = _total;
                break;
            case 'scdTotal':
                this.totalscd = _total;
                break;
            case 'clkTotal':
                this.totalclk = _total;
                break;
        }
    }

    forSplit(text): string {
        const val = text;
        return val;
    }

    copyVoiceCallFormValue() {
        this.voiceCallData.clpCompanyId = this.user?.cLPCompanyID;
        this.voiceCallData.clpUserId = this.user?.cLPUserID;
        this.voiceCallData.startDate = this.datepipe.transform(this.voiceCallForm.controls.startDate.value, 'MMddyyyy') ?? "";
        this.voiceCallData.endDate = this.datepipe.transform(this.voiceCallForm.controls.endDate.value, 'MMddyyyy') ?? "";
        this.voiceCallData.officeCode = !isNullOrUndefined(this.voiceCallForm?.controls.ddOffice.value) ? this.voiceCallForm?.controls.ddOffice.value : 0;
        this.voiceCallData.teamCode = !isNullOrUndefined(this.voiceCallForm?.controls.ddTeam.value) ? this.voiceCallForm?.controls.ddTeam.value : 0;
        this.voiceCallData.groupBy = this.voiceCallForm?.controls.groupBy.value;
    }

    prepareTextMsgLogForm() {
        const now = new Date();
        return this.fb.group({
            startDate: new FormControl(new Date(now.getFullYear(), now.getMonth() - 1, 1), [Validators.required]),
            endDate: new FormControl(new Date(now.getFullYear(), now.getMonth(), 0), [Validators.required]),
            ddTeam: new FormControl(0),
            ddOffice: new FormControl(0),
            groupBy: new FormControl('CLPUser'),
        });
    }

    public saveExcel(component): void {
        this._localService.saveExcel(component, 'Voice Call List', true, this.total);
    }

    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            this.voiceCallForm.controls.startDate.setValue(startDt);

        }
        if (endDt) {
            this.voiceCallForm.controls.endDate.setValue(endDt)
        }
    }

    get visibleColumns() {
        return this.columns.filter(col => !this.hiddenFields?.includes(col.field));
    }

    get displayedColumns() {
        return this.visibleColumns.map(col => col.field);
    }

    get visibleColumnsCnl() {
        return this.columnsCNL;
    }

    get displayedCnlColumns() {
        return this.visibleColumnsCnl.map(col => col.field);
    }

    public onTabSelect(e: any): void {
        switch (e.title) {
            case 'Total Calls':
                this.hiddenFields = ['noRing', 'pitchRate', 'answerRate', 'pitchCallsPerDay'];
                this.setTotalCallsGrid(this.totalVoiceRpt);
                break;
            case 'Inbound':
                this.hiddenFields = ['team', 'office', 'pitchCallsPerDay'];
                this.setInboundGrid(this.inboundRpt);
                this.setGridIn(this.inboundRptList);
                break;
            case 'Outbound - Click-To-Call':
                this.hiddenFields = ['noRing', 'pitchRate', 'answerRate', 'connected'];
                this.setOutBoundGrid(this.outClickToCallRpt);
                break;
            case 'Outbound - Scheduled':
                this.hiddenFields = ['noRing', 'pitchRate', 'answerRate', , 'connected'];
                this.setOutScheduleGrid(this.outScheduledRpt);
                break;
            case 'SAM Cancelled':
                //this.hiddenFields = ['noRing', 'pitchRate', 'answerRate'];
                this.setSamCancelledGrid(this.voiceCallCancelRpt);
                break;

        }
    }

    setTotalCallsGrid(list) {
        this.totalCallsdataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.totalCallsdataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_totalCalls_grid') ? this._localService.getPageSize('voice_call_totalCalls_grid') : 50;
            }
            if (this.totalCallsSort) {
                this.totalCallsdataSource.sort = this.totalCallsSort;
                const sortState: Sort = this._localService.getSortState('voice_call_totalCalls_grid');
                this.totalCallsSort.active = sortState?.active;
                this.totalCallsSort.direction = sortState?.direction;
                this.totalCallsSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    setInboundGrid(list) {
        this.inbounddataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.inbounddataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_inbound_grid') ? this._localService.getPageSize('voice_call_inbound_grid') : 50;
            }
            if (this.inboundSort) {
                this.inbounddataSource.sort = this.inboundSort;
                const sortState: Sort = this._localService.getSortState('voice_call_inbound_grid');
                this.inboundSort.active = sortState?.active;
                this.inboundSort.direction = sortState?.direction;
                this.inboundSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    setOutBoundGrid(list) {
        this.outboundCalldataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.outboundCalldataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_outboundCalls_grid') ? this._localService.getPageSize('voice_call_outboundCalls_grid') : 50;
            }
            if (this.outboundCallSort) {
                this.outboundCalldataSource.sort = this.outboundCallSort;
                const sortState: Sort = this._localService.getSortState('voice_call_outboundCalls_grid');
                this.outboundCallSort.active = sortState?.active;
                this.outboundCallSort.direction = sortState?.direction;
                this.outboundCallSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    setOutScheduleGrid(list) {
        this.outboundScheduleddataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.outboundScheduleddataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_outboundSchedule_grid') ? this._localService.getPageSize('voice_call_outboundSchedule_grid') : 50;
            }
            if (this.outboundScheduledSort) {
                this.outboundScheduleddataSource.sort = this.outboundScheduledSort;
                const sortState: Sort = this._localService.getSortState('voice_call_outboundSchedule_grid');
                this.outboundCallSort.active = sortState?.active;
                this.outboundCallSort.direction = sortState?.direction;
                this.outboundCallSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    setSamCancelledGrid(list) {
        this.samCancelledSortdataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.samCancelledSortdataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_samCancelled_grid') ? this._localService.getPageSize('voice_call_samCancelled_grid') : 50;
            }
            if (this.samCancelledSort) {
                this.samCancelledSortdataSource.sort = this.samCancelledSort;
                const sortState: Sort = this._localService.getSortState('voice_call_samCancelled_grid');
                this.outboundCallSort.active = sortState?.active;
                this.outboundCallSort.direction = sortState?.direction;
                this.outboundCallSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    setGridIn(list) {
        this.dataSourceIn = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.dataSourceIn.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('voice_call_inboundList_grid') ? this._localService.getPageSize('voice_call_inboundList_grid') : 50;
            }
            if (this.inboundListSort) {
                this.dataSourceIn.sort = this.inboundListSort;
                const sortState: Sort = this._localService.getSortState('voice_call_inboundList_grid');
                this.inboundListSort.active = sortState?.active;
                this.inboundListSort.direction = sortState?.direction;
                this.inboundListSort.sortChange.emit(sortState);
            }
        }, 500)
    }

    visibleFieldsMap = {
        totalCalls: this.columns
            .filter(col => !['noRing', 'pitchRate', 'answerRate', 'pitchCallsPerDay'].includes(col.field))
            .map(col => col.field),

        inbound: this.columns
            .filter(col => !['team', 'office', 'pitchCallsPerDay'].includes(col.field))
            .map(col => col.field),

        inboundList: this.columns
            .filter(col => !['office', 'pitchCallsPerDay'].includes(col.field))
            .map(col => col.field),

        outboundClickToCall: this.columns
            .filter(col => !['noRing', 'pitchRate', 'answerRate'].includes(col.field))
            .map(col => col.field),

        outboundScheduled: this.columns
            .filter(col => !['noRing', 'pitchRate', 'answerRate'].includes(col.field))
            .map(col => col.field),

        sAMCancelled: this.columnsCNL.map(col => col.field),
    };

    getVisibleColumns(tableKey) {
        return this.columns.filter(col => this.visibleFieldsMap[tableKey].includes(col.field));
    }

    getDisplayedColumns(tableKey) {
        return this.visibleFieldsMap[tableKey];
    }

    getVisibleCnlColumns(tableKey) {
        return this.columns.filter(col => this.visibleFieldsMap[tableKey].includes(col.field));
    }

    getDisplayedCnlColumns(tableKey) {
        return this.visibleFieldsMap[tableKey];
    }

    exportPDF(title) {
        switch (title) {
            case 'Total Calls':
                this.exporting1 = true;
                this.addTimeout(() => {
                    this.pdfExport.saveAs('Total Calls.pdf')
                }, 100);
                this.addTimeout(() => {
                    this.exporting1 = false,
                        this.setTotalCallsGrid(this.totalVoiceRpt);
                }, 500);
                break;
            case 'Inbound':
                this.exporting2 = true;
                this.addTimeout(() => {
                    this.pdfExport.saveAs('Inbound.pdf')
                }, 100);
                this.addTimeout(() => {
                    this.exporting2 = false,
                        this.setInboundGrid(this.inboundRpt);
                }, 500);
                break;
            case 'Outbound - Click-To-Call':
                this.exporting3 = true;
                this.addTimeout(() => {
                    this.pdfExport.saveAs('Outbound - Click-To-Call.pdf')
                }, 100);
                this.addTimeout(() => {
                    this.exporting3 = false,
                        this.setOutBoundGrid(this.outClickToCallRpt);
                }, 500);
                break;
            case 'Outbound - Scheduled':
                this.exporting4 = true;
                this.addTimeout(() => {
                    this.pdfExport.saveAs('Outbound - Scheduled.pdf')
                }, 100);
                this.addTimeout(() => {
                    this.exporting4 = false,
                        this.setOutScheduleGrid(this.outScheduledRpt);
                }, 500);
                break;
            case 'SAM Cancelled':
                this.exporting5 = true;
                this.addTimeout(() => {
                    this.pdfExport.saveAs('SAM Cancelled.pdf')
                }, 100);
                this.addTimeout(() => {
                    this.exporting5 = false,
                        this.setSamCancelledGrid(this.voiceCallCancelRpt);
                }, 500);
                break;

        }
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
